import { Component, OnInit, Inject, ViewChild } from "@angular/core";

import * as jwtDecode from "jwt-decode";
import { DaoService } from "src/app/services/dao.service";
import { LstorageService } from "src/app/services/lstorage.service";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  UntypedFormBuilder,
} from "@angular/forms";
import { Router } from "@angular/router";
import { DataSource } from "@angular/cdk/table";
// import {
//   MatTableDataSource,
//   MatDialog,
//   MatPaginator,
//   MAT_DIALOG_DATA,
//   MatDialogRef,
// } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: "app-analyticsform",
  templateUrl: "./analyticsform.component.html",
  styleUrls: ["./analyticsform.component.scss"],
})
export class AnalyticsformComponent implements OnInit {
  created_By: any;
  modified_By: any;
  analyticsEdit: any;
  analytic: any;
  analyticsList: any;
  isGeneralType = false;
  apiMappedAttribute: string;
  entity: any;
  requiredAttribute: any;
  logo: any;
  logoPreview: any;
  basedata: any;
  aid: any;

  analytics = this.formBuilder.group({
    analyticsId: [""],
    name: ["", [Validators.required]],
    powerBIURL: ["", [Validators.required]],
    type: [""],
    entities: [""],
    Attributes: [""],
    isActive: ["true"],
    createdBy: [""],
    createdOn: ["2020-01-03T15:50:10.213Z"],
    modifiedBy: [""],
    modifiedOn: ["2020-01-03T15:50:10.213Z"],
  });

  types: string[] = ["Entity analysis", "General"];

  public validator = {
    errorMessage: "",
    UniqueAnalytics: false,
  };
  //formBuilder: any;

  constructor(
    private sanitizer: DomSanitizer,
    private daoService: DaoService,
    // private fb: FormBuilder,
    private formBuilder: UntypedFormBuilder,
    private token: LstorageService,
    public dialogRef: MatDialogRef<AnalyticsformComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    // this.daoService.getEntity().subscribe((data) => {
    //   this.entity = data;
    // });
    this.daoService.getEntities().subscribe((data) => {
      this.entity = data;
    });
  }

  ngOnInit() {
    var analyticsid = this.token.getAnalyticeFormId();
    if (analyticsid) {
      this.modified_By = jwtDecode(this.token.getToken());
      this.daoService.getAnalyticsById(analyticsid).subscribe((data: any) => {
        console.log(data.attributes);

        if (data.type == "General") {
          this.isGeneralType = true;
        } else {
          this.isGeneralType = false;
        }

        this.daoService
          .getAttributeByEntity(data.entities)
          .subscribe((AttributeData) => {
            this.requiredAttribute = AttributeData;
          });

        this.logoPreview = data.logo;

        this.analytics = this.formBuilder.group({
          analyticsId: [analyticsid],
          name: [data.name, [Validators.required]],
          powerBIURL: [data.powerBIURL, [Validators.required]],
          type: [data.type, [Validators.required]],
          entities: [data.entities, [Validators.required]],
          Attributes: [data.attributes],
          isActive: [data.isActive],
          modifiedBy: [this.modified_By.unique_name],
          modifiedOn: ["2020-01-03T15:50:10.213Z"],
        });
      });
    } else {
      this.created_By = jwtDecode(this.token.getToken());
      this.analytics = this.formBuilder.group({
        analyticsId: [""],
        name: ["", [Validators.required]],
        powerBIURL: ["", [Validators.required]],
        type: ["", [Validators.required]],
        entities: [""],
        Attributes: [""],
        isActive: ["true"],
        createdBy: [this.created_By.unique_name],
        createdOn: ["2020-01-03T15:50:10.213Z"],
        modifiedBy: [""],
        modifiedOn: ["2020-01-03T15:50:10.213Z"],
      });
    }
  }

  Entitychange(event) {
    this.daoService.getAttributeByEntity(event).subscribe((data) => {
      this.requiredAttribute = data;
    });
  }

  getSelectedType(event) {
    if (event.value == "General") {
      this.isGeneralType = true;
    } else {
      this.isGeneralType = false;
    }
  }

  onfileselected(event) {
    this.logo = <File>event.target.files[0];

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => {
        // called once readAsDataURL is completed
        this.logoPreview = reader.result;
      };
    }
  }

  createAnalytics() {
    this.aid = null;
    this.validator.UniqueAnalytics = false;
    console.log(this.analytics.value.analyticsId);
    if (this.analytics.value.analyticsId) {
      this.daoService.AddAnalytics(this.analytics.value).subscribe(
        (data: any) => {
          if (data.isSuccess) {
            this.daoService.dynamiceditAnalyticsList(data.data);
            this.aid = data.data.analyticsId;
            if (this.logo) {
              const fd = new FormData();
              fd.append("logo", this.logo, this.logo.name);
              this.daoService
                .uploadAnalyticsLogo(fd, this.aid)
                .subscribe((data: any) => {
                  this.dialogRef.close();
                });
              (error) => {
                this.validator.UniqueAnalytics = true;
                this.validator.errorMessage = error.error.userMessage;
              };
            } else {
              this.dialogRef.close();
            }
          }
          //this.dialogRef.close();
        },
        (error) => {
          this.validator.UniqueAnalytics = true;
          this.validator.errorMessage = error.error.userMessage;
        }
      );
    } else {
      this.daoService.AddAnalytics(this.analytics.value).subscribe(
        (data: any) => {
          if (data.isSuccess) {
            this.daoService.dynamicAnalyticsList(data.data);
            this.aid = data.data.analyticsId;
            if (this.logo) {
              const fd = new FormData();
              fd.append("logo", this.logo, this.logo.name);
              this.daoService
                .uploadAnalyticsLogo(fd, this.aid)
                .subscribe((data: any) => {
                  this.dialogRef.close();
                });
              (error) => {
                this.validator.UniqueAnalytics = true;
                this.validator.errorMessage = error.error.userMessage;
              };
            } else {
              this.dialogRef.close();
            }
          }
          //this.dialogRef.close();
        },
        (error) => {
          this.validator.UniqueAnalytics = true;
          this.validator.errorMessage = error.error.userMessage;
        }
      );
    }
  }

  closeAnalyticsForm() {
    this.dialogRef.close();
  }
}
